import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getAvailableHost = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule-ruleset/available-hosts?${queries}` });

  return data?.data;
};

export default getAvailableHost;
